import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgPencil = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.4492 7.54807L19.6483 9.34893C19.4647 9.53253 19.1678 9.53253 18.9842 9.34893L14.6481 5.01282C14.4645 4.82921 14.4645 4.53233 14.6481 4.34873L16.449 2.54787C17.1795 1.81738 18.367 1.81738 19.1014 2.54787L21.4492 4.89562C22.1836 5.62612 22.1836 6.81367 21.4492 7.54807ZM13.1012 5.89566L2.84298 16.1539L2.01482 20.9002C1.90154 21.5408 2.46015 22.0955 3.1008 21.9861L7.84708 21.1541L18.1053 10.8959C18.2889 10.7123 18.2889 10.4154 18.1053 10.2318L13.7692 5.89566C13.5817 5.71206 13.2848 5.71206 13.1012 5.89566ZM6.84705 15.2749C6.63219 15.0601 6.63219 14.7163 6.84705 14.5015L12.8629 8.48561C13.0778 8.27076 13.4215 8.27076 13.6364 8.48561C13.8512 8.70046 13.8512 9.04423 13.6364 9.25908L7.62051 15.2749C7.40566 15.4898 7.0619 15.4898 6.84705 15.2749ZM5.43683 18.5602H7.31191V19.9783L4.79228 20.4197L3.57738 19.2048L4.01881 16.6852H5.43683V18.5602Z", fill: props.fill }));
});
export default SvgPencil;
